import * as React from 'react';
import * as uniqid from 'uniqid';

interface IInputProps {
  type: string;
  label?: string;
  placeholder?: string;
  name?: string;
  value?: any;
  onChange?: any;
  required?: boolean;
  id?: string;
  autoFocus?: boolean;
  maxLength?: number;
  disabled?: boolean;
}

class Input extends React.Component<IInputProps> {

  private _input: any = React.createRef();

  componentDidUpdate(prevProps: IInputProps, prevState: any) {
    if (this.props.autoFocus === true) {
      this._input.focus();
    }
  }

  render() {
    const className: string = 'input';

    const { disabled, label, type, placeholder, value, name, onChange, id, autoFocus, maxLength } = this.props;
    let { required } = this.props;

    let Id: string;

    if (!required) {
      required = false;
    }

    switch (type) {
      case 'checkbox':
        Id = uniqid('checkbox-');
        return (
          <div className="checkbox">
            <label className="checkbox__label" htmlFor={id}>{label}
              <input
                disabled={disabled}
                ref={i => (this._input = i)}
                className="checkbox__input"
                id={id}
                name={name} 
                checked={!!value} 
                type="checkbox" 
                onChange={onChange}
                autoFocus={autoFocus}
              />
              <div className="checkbox__checkmark" />
            </label>
          </div>
        );
        
      case 'radio':
        Id = uniqid('radio-');
        return (
          <div className="radio">
            <label className="radio__label" htmlFor={Id}>{label}
              <input
                disabled={disabled}
                ref={i => (this._input = i)}
                className="radio__input" id={Id} name={name}
                value={value} type="radio" onChange={onChange}
                autoFocus={autoFocus}
              />
              <div className="radio__checkmark" />
            </label>
          </div>
        );

      case 'textarea':
        Id = uniqid('textarea-');
        return (
          <React.Fragment>
            {/* {label &&
              <label htmlFor={Id} className={`label${required === true ? ' required' : ''}`}>{label}</label>} */}
            <textarea
              disabled={disabled}
              id={Id}
              ref={i => (this._input = i)}
              name={name}
              value={value || ''}
              className={`textarea ${className}`}
              placeholder={placeholder}
              required={required}
              autoFocus={autoFocus}
              onChange={onChange}
            />
            
          </React.Fragment>
        );

      default:
        Id = uniqid('input-');
        return (
          <React.Fragment>
            {label &&
              <label htmlFor={Id} className={`label${required === true ? ' required' : ''}`}>{label}</label>}
            <input
              disabled={disabled}
              id={Id}
              ref={i => (this._input = i)}
              type={type}
              name={name}
              value={value || ''}
              className={`input ${className}` + (type ? ' ' + className + '--' + type : '')}
              placeholder={placeholder}
              required={required}
              autoFocus={autoFocus}
              onChange={onChange}
              maxLength={maxLength}
            />
          </React.Fragment>
        );

    }
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/modules/Form/Input.tsx